(function ($, Cobalt, undefined) {
    Cobalt.SourcePoint = {
        site: 'Curse',
        initialize: function () {
            var wrapper = document.createElement('div');

            document.body.classList.add('sourcepoint-blocked');
            wrapper.classList.add('sourcepoint-wrapper');
            Cobalt.SourcePoint.createSiteLogo(wrapper);
            Cobalt.SourcePoint.createHeader(wrapper);
            Cobalt.SourcePoint.createParagraph(wrapper);
            Cobalt.SourcePoint.createButton(wrapper);
            document.body.appendChild(wrapper);
        },
        createSiteLogo: function (wrapper) {
            var siteLogo = document.createElement('div');

            wrapper.appendChild(siteLogo);
        },
        createHeader: function (wrapper) {
            var header = document.createElement('h2');

            header.innerHTML = "It looks like you're running an ad blocker :(";
            wrapper.appendChild(header);
        },
        createParagraph: function (wrapper) {
            var paragraph = document.createElement('p');

            paragraph.innerHTML = "Your ad blocker is interfering with the operation of this site. Please show your support and whitelist " + Cobalt.SourcePoint.site;
            wrapper.appendChild(paragraph);
        },
        createButton: function (wrapper) {
            var button = document.createElement('button');

            button.innerHTML = "I don't want to support " + Cobalt.SourcePoint.site;
            button.addEventListener('click', function (e) {
                e.preventDefault();
                document.body.removeChild(e.target.parentNode);
                document.body.classList.remove('sourcepoint-blocked');
            });
            wrapper.appendChild(button);
        }
    };

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.SourcePoint.js